import { IUserState } from '@/interfaces/store';

const state: IUserState = {
  currentUser: {},
};

export default state;
